<body>
  <section class="second-section">
    <div class="header-section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-5">
            <div class="logo">
              <!-- Generator: Adobe Illustrator 21.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 1633 411"
                style="enable-background: new 0 0 1633 411"
                xml:space="preserve"
              >
                <linearGradient
                  id="SVGID_1_"
                  gradientUnits="userSpaceOnUse"
                  x1="134.3913"
                  y1="200.0357"
                  x2="348.631"
                  y2="200.0357"
                >
                  <stop offset="0" style="stop-color: #cc9401" />
                  <stop offset="0.1904" style="stop-color: #cd9502" />
                  <stop offset="0.2046" style="stop-color: #ca9603" />
                  <stop offset="0.2162" style="stop-color: #c09807" />
                  <stop offset="0.2269" style="stop-color: #af9c0f" />
                  <stop offset="0.2371" style="stop-color: #96a118" />
                  <stop offset="0.2468" style="stop-color: #77a825" />
                  <stop offset="0.2562" style="stop-color: #52b035" />
                  <stop offset="0.2611" style="stop-color: #3bb53e" />
                  <stop offset="0.4793" style="stop-color: #3bb93c" />
                  <stop offset="0.4804" style="stop-color: #3fb43b" />
                  <stop offset="0.5023" style="stop-color: #88622a" />
                  <stop offset="0.5178" style="stop-color: #b62e1f" />
                  <stop offset="0.5254" style="stop-color: #c81a1b" />
                  <stop offset="0.7275" style="stop-color: #c81a1b" />
                  <stop
                    offset="0.7381"
                    style="stop-color: #c9261a; stop-opacity: 0.9975"
                  />
                  <stop
                    offset="0.757"
                    style="stop-color: #cb4417; stop-opacity: 0.9931"
                  />
                  <stop
                    offset="0.77"
                    style="stop-color: #cd5d15; stop-opacity: 0.99"
                  />
                  <stop offset="1" style="stop-color: #cc5d15" />
                </linearGradient>
                <path
                  class="st0"
                  d="M342,148.6h-34.3c-3.6,0-6.6,3-6.6,6.6v32.9c0,0.9,0.2,1.8,0.6,2.6l-14.6,14.6c-0.2,0-0.4,0-0.6,0h-34.3
                  c-0.2,0-0.3,0-0.5,0L237,190.7c0.3-0.8,0.5-1.7,0.5-2.6v-32.9c0-3.6-3-6.6-6.6-6.6h-34.3c-3.6,0-6.6,3-6.6,6.6v32.9
                  c0,0.9,0.2,1.8,0.6,2.6l-14.6,14.6c-0.2,0-0.4,0-0.6,0H141c-3.6,0-6.6,3-6.6,6.6v32.9c0,3.6,3,6.6,6.6,6.6h34.3c3.6,0,6.6-3,6.6-6.6
                  V212c0-1-0.2-2-0.7-2.9l14.4-14.4c0.3,0,0.6,0.1,0.9,0.1h34.3c0.3,0,0.6,0,1-0.1l14.4,14.4c-0.4,0.9-0.7,1.9-0.7,2.9v32.9
                  c0,3.6,3,6.6,6.6,6.6h34.3c3.6,0,6.6-3,6.6-6.6V212c0-1-0.2-2-0.7-2.9l14.4-14.4c0.3,0,0.6,0.1,0.9,0.1H342c3.6,0,6.6-3,6.6-6.6
                  v-32.9C348.6,151.6,345.7,148.6,342,148.6z"
                />
                <g>
                  <path
                    class="st1"
                    d="M220.9,206.1h-23.2c-1.1,0-2,0.9-2,2v23.2c0,1.1,0.9,2,2,2h23.2c1.1,0,2-0.9,2-2v-23.2
                      C222.9,207,222,206.1,220.9,206.1z"
                  />
                  <path
                    class="st1"
                    d="M198.8,245.8c-0.5,0-0.9,0.4-0.9,0.9v4.9c0,0.5,0.4,0.9,0.9,0.9h4.9c0.5,0,0.9-0.4,0.9-0.9v-4.9
                      c0-0.5-0.4-0.9-0.9-0.9H198.8z"
                  />
                  <path
                    class="st1"
                    d="M177.5,145.3v3.5c0,0.9,0.7,1.6,1.6,1.6h3.7c0.9,0,1.6-0.7,1.6-1.6v-3.5c0-0.9-0.7-1.6-1.6-1.6h-3.7
                      C178.2,143.7,177.5,144.4,177.5,145.3z"
                  />
                  <path
                    class="st1"
                    d="M211.2,100.9h-27.5c-2.7,0-4.8,2.2-4.8,4.8v26.4c0,2.7,2.2,4.8,4.8,4.8h27.5c2.7,0,4.8-2.2,4.8-4.8v-26.4
                      C216,103,213.9,100.9,211.2,100.9z"
                  />
                  <path
                    class="st1"
                    d="M220.6,246.6v9.6c0,1.1,0.9,2,2,2h9.6c1.1,0,2-0.9,2-2v-9.6c0-1.1-0.9-2-2-2h-9.6
                      C221.5,244.6,220.6,245.5,220.6,246.6z"
                  />
                  <path
                    class="st1"
                    d="M143.3,180h22c3,0,5.5-2.4,5.5-5.5v-23.1c0-3-2.4-5.5-5.5-5.5h-22c-3,0-5.5,2.4-5.5,5.5v23.1
                      C137.8,177.5,140.2,180,143.3,180z"
                  />
                  <path
                    class="st1"
                    d="M167.2,139.2c0.9,0,1.6-0.7,1.6-1.6v-11.5c0-0.9-0.7-1.6-1.6-1.6h-11.9c-0.9,0-1.6,0.7-1.6,1.6v11.5
                      c0,0.9,0.7,1.6,1.6,1.6H167.2z"
                  />
                  <path
                    class="st1"
                    d="M228.5,283v4.9c0,0.5,0.4,0.9,0.9,0.9h4.9c0.5,0,0.9-0.4,0.9-0.9V283c0-0.5-0.4-0.9-0.9-0.9h-4.9
                      C228.9,282.1,228.5,282.5,228.5,283z"
                  />
                  <path
                    class="st1"
                    d="M232.8,126.6h-6.3c-0.8,0-1.4,0.6-1.4,1.4v6c0,0.8,0.6,1.4,1.4,1.4h6.3c0.8,0,1.4-0.6,1.4-1.4v-6
                      C234.2,127.2,233.6,126.6,232.8,126.6z"
                  />
                  <path
                    class="st1"
                    d="M255.5,121.9c0.8,0,1.4-0.6,1.4-1.4v-3.8c0-0.8-0.6-1.4-1.4-1.4h-4c-0.8,0-1.4,0.6-1.4,1.4v3.8
                      c0,0.8,0.6,1.4,1.4,1.4H255.5z"
                  />
                  <path
                    class="st1"
                    d="M285,158.2c0.8,0,1.4-0.6,1.4-1.4V153c0-0.8-0.6-1.4-1.4-1.4h-4c-0.8,0-1.4,0.6-1.4,1.4v3.8
                      c0,0.8,0.6,1.4,1.4,1.4H285z"
                  />
                  <path
                    class="st1"
                    d="M261.4,175v18.2c0,2.3,1.8,4.1,4.1,4.1h19.1c2.3,0,4.1-1.8,4.1-4.1V175c0-2.3-1.8-4.1-4.1-4.1h-19.1
                      C263.2,170.9,261.4,172.7,261.4,175z"
                  />
                  <path
                    class="st1"
                    d="M250.1,276.7c0,1.1,0.9,2,2,2h5.1c1.1,0,2-0.9,2-2v-6.2c0-1.1-0.9-2-2-2h-5.1c-1.1,0-2,0.9-2,2V276.7z"
                  />
                  <path
                    class="st1"
                    d="M129.2,198.8h10.3c0.9,0,1.6-0.7,1.6-1.6v-9.9c0-0.9-0.7-1.6-1.6-1.6h-10.3c-0.9,0-1.6,0.7-1.6,1.6v9.9
                      C127.6,198.1,128.3,198.8,129.2,198.8z"
                  />
                  <path
                    class="st1"
                    d="M172.1,185.7c-0.9,0-1.6,0.7-1.6,1.6v4.6c0,0.9,0.7,1.6,1.6,1.6h4.9c0.9,0,1.6-0.7,1.6-1.6v-4.6
                      c0-0.9-0.7-1.6-1.6-1.6H172.1z"
                  />
                  <path
                    class="st1"
                    d="M243.1,73.9c-35.8,0-68.3,14.6-91.6,38.2c18.8-16.2,43.2-26,70-26c2.2,0,4.3,0.1,6.4,0.2h-3.4
                      c-0.9,0-1.6,0.7-1.6,1.6v11c0,0.9,0.7,1.6,1.6,1.6h11.5c0.9,0,1.6-0.7,1.6-1.6v-11c0-0.2-0.1-0.5-0.1-0.7c4.7,0.7,9.3,1.7,13.7,3
                      v5.3c0,0.9,0.7,1.6,1.6,1.6h5.8c0.9,0,1.6-0.7,1.6-1.6v-2.2c5.2,2,10.2,4.4,15,7.2h-7c-1.9,0-3.4,1.5-3.4,3.4v28.3
                      c0,1.9,1.5,3.4,3.4,3.4h29.4c1.9,0,3.4-1.5,3.4-3.4v-10.8c5.8,6.4,10.8,13.5,14.9,21.1h28.6c4.8,0,8.6,3.9,8.6,8.6v40.6
                      c0,4.8-3.9,8.6-8.6,8.6h-16c-0.5,8.2-2,16.2-4.3,23.8h-6.7c-2.3,0-4.1,1.8-4.1,4.1v20.3c-2.1,3.5-4.4,6.8-6.8,10v-4
                      c0-0.5-0.4-0.9-0.9-0.9h-4.9c-0.5,0-0.9,0.4-0.9,0.9v4.9c0,0.5,0.4,0.9,0.9,0.9h4.4c-1.9,2.4-3.9,4.6-5.9,6.8h-27
                      c-2.3,0-4.1,1.8-4.1,4.1v18.7c-14.1,6.8-30,10.7-46.7,10.7c-0.3,0-0.6,0-0.9,0c0,0,0-0.1,0-0.1v-28.1c0-2.3-1.8-4.1-4.1-4.1h-29.3
                      c-2.3,0-4.1,1.8-4.1,4.1v21.2c-9.1-3.5-17.7-8.2-25.4-13.9h11.9c1.8,0,3.3-1.5,3.3-3.3v-12.7c0-1.8-1.5-3.3-3.3-3.3h-12.7
                      c-1.8,0-3.3,1.5-3.3,3.3v12.7c0,0,0,0.1,0,0.1c-23-18.8-38-46.8-39.4-78.5c-0.1,1.6-0.1,3.1-0.1,4.7c0,17.2,3.4,33.5,9.4,48.5
                      c0,0,0,0,0,0c0,0,0,0,0,0c1.2,2.9,2.5,5.8,3.9,8.7c0,0,0,0,0,0c1.4,2.8,2.9,5.6,4.5,8.3c0,0,0,0,0,0c1.6,2.7,3.3,5.3,5.1,7.9
                      c0,0,0,0.1,0.1,0.1c1.8,2.5,3.6,5,5.6,7.4c0,0,0.1,0.1,0.1,0.1c1.9,2.4,3.9,4.7,6,7c0,0.1,0.1,0.1,0.1,0.2c2.1,2.2,4.2,4.4,6.5,6.4
                      c0.1,0.1,0.1,0.1,0.2,0.2c2.2,2,4.5,4,6.9,5.9c0.1,0.1,0.2,0.1,0.3,0.2c1.2,0.9,2.4,1.9,3.6,2.8c0,0,0.1,0.1,0.1,0.1
                      c1.2,0.9,2.3,1.7,3.5,2.5c0.1,0.1,0.2,0.2,0.3,0.2c1.2,0.8,2.5,1.7,3.7,2.4c0.1,0.1,0.2,0.1,0.3,0.2c1.2,0.7,2.4,1.5,3.6,2.2
                      c0.1,0.1,0.3,0.2,0.4,0.2c1.3,0.7,2.5,1.4,3.8,2.1c0.2,0.1,0.3,0.2,0.5,0.3c1.2,0.6,2.4,1.2,3.6,1.8c0.2,0.1,0.3,0.2,0.5,0.2
                      c1.3,0.6,2.6,1.2,3.9,1.8c0.2,0.1,0.4,0.2,0.6,0.3c1.2,0.5,2.4,1,3.6,1.5c0.2,0.1,0.3,0.1,0.5,0.2c1.3,0.5,2.7,1,4,1.5
                      c0.3,0.1,0.5,0.2,0.8,0.3c1.2,0.4,2.5,0.9,3.7,1.2c0.2,0.1,0.3,0.1,0.5,0.2c1.4,0.4,2.7,0.8,4.1,1.2c0.3,0.1,0.6,0.2,0.9,0.2
                      c1.3,0.3,2.5,0.7,3.8,1c0.2,0,0.3,0.1,0.5,0.1c1.4,0.3,2.8,0.6,4.2,0.9c0.3,0.1,0.7,0.1,1,0.2c1.3,0.3,2.6,0.5,4,0.7
                      c0.1,0,0.3,0,0.4,0.1c1.4,0.2,2.9,0.4,4.3,0.6c0.3,0,0.7,0.1,1,0.1c1.4,0.2,2.8,0.3,4.2,0.4c0.1,0,0.2,0,0.2,0
                      c1.5,0.1,2.9,0.2,4.4,0.3c0.4,0,0.7,0,1.1,0c1.5,0.1,3,0.1,4.5,0.1s3,0,4.5-0.1c0.4,0,0.7,0,1.1,0c1.5-0.1,3-0.1,4.4-0.3
                      c0.1,0,0.2,0,0.2,0c1.4-0.1,2.8-0.2,4.2-0.4c0.3,0,0.7-0.1,1-0.1c1.4-0.2,2.9-0.4,4.3-0.6c0.1,0,0.3,0,0.4-0.1
                      c1.3-0.2,2.7-0.4,4-0.7c0.3-0.1,0.7-0.1,1-0.2c1.4-0.3,2.8-0.6,4.2-0.9c0.2,0,0.3-0.1,0.5-0.1c1.3-0.3,2.6-0.6,3.8-1
                      c0.3-0.1,0.6-0.2,0.9-0.2c1.4-0.4,2.8-0.8,4.1-1.2c0.2-0.1,0.3-0.1,0.5-0.2c1.2-0.4,2.5-0.8,3.7-1.2c0.3-0.1,0.5-0.2,0.8-0.3
                      c1.4-0.5,2.7-1,4-1.5c0.2-0.1,0.3-0.1,0.5-0.2c1.2-0.5,2.4-1,3.6-1.5c0.2-0.1,0.4-0.2,0.6-0.3c1.3-0.6,2.6-1.2,3.9-1.8
                      c0.2-0.1,0.3-0.2,0.5-0.2c1.2-0.6,2.4-1.2,3.6-1.8c0.2-0.1,0.3-0.2,0.5-0.3c1.3-0.7,2.6-1.4,3.8-2.1c0.1-0.1,0.3-0.2,0.4-0.2
                      c1.2-0.7,2.4-1.4,3.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2c1.3-0.8,2.5-1.6,3.7-2.4c0.1-0.1,0.2-0.2,0.3-0.2c1.2-0.8,2.4-1.7,3.5-2.5
                      c0,0,0.1-0.1,0.1-0.1c1.2-0.9,2.4-1.8,3.6-2.8c0.1-0.1,0.2-0.1,0.3-0.2c2.4-1.9,4.7-3.9,6.9-5.9c0.1-0.1,0.1-0.1,0.2-0.2
                      c2.2-2.1,4.4-4.2,6.5-6.4c0-0.1,0.1-0.1,0.1-0.2c2.1-2.2,4.1-4.6,6-6.9c0,0,0.1-0.1,0.1-0.1c1.9-2.4,3.8-4.9,5.6-7.4
                      c0,0,0-0.1,0.1-0.1c1.8-2.6,3.5-5.2,5.1-7.9c0,0,0,0,0,0c1.6-2.7,3.1-5.5,4.5-8.3c0,0,0,0,0,0c8.5-17.2,13.3-36.6,13.3-57.2
                      C372.1,131.6,314.4,73.9,243.1,73.9z"
                  />
                  <path
                    class="st1"
                    d="M250.1,158.6c0,0.9,0.7,1.6,1.6,1.6H262c0.9,0,1.6-0.7,1.6-1.6v-9.9c0-0.9-0.7-1.6-1.6-1.6h-10.3
                      c-0.9,0-1.6,0.7-1.6,1.6V158.6z"
                  />
                  <path
                    class="st1"
                    d="M314.5,208.3h-6.3c-0.8,0-1.4,0.6-1.4,1.4v6c0,0.8,0.6,1.4,1.4,1.4h6.3c0.8,0,1.4-0.6,1.4-1.4v-6
                      C315.8,208.9,315.2,208.3,314.5,208.3z"
                  />
                </g>
                <linearGradient
                  id="SVGID_2_"
                  gradientUnits="userSpaceOnUse"
                  x1="199.0999"
                  y1="315.7006"
                  x2="299.533"
                  y2="78.0303"
                >
                  <stop offset="0" style="stop-color: #277dc6" />
                  <stop offset="0.4761" style="stop-color: #3298d2" />
                  <stop offset="1" style="stop-color: #3db2dd" />
                </linearGradient>
                <path
                  class="st2"
                  d="M222.9,205.8V229c0,1.1-0.9,2-2,2h-23.2c-1.1,0-2-0.9-2-2v-23.2c0-1.1,0.9-2,2-2h23.2
                  C222,203.8,222.9,204.7,222.9,205.8z M198.8,243.5c-0.5,0-0.9,0.4-0.9,0.9v4.9c0,0.5,0.4,0.9,0.9,0.9h4.9c0.5,0,0.9-0.4,0.9-0.9
                  v-4.9c0-0.5-0.4-0.9-0.9-0.9H198.8z M177.5,143.1v3.5c0,0.9,0.7,1.6,1.6,1.6h3.7c0.9,0,1.6-0.7,1.6-1.6v-3.5c0-0.9-0.7-1.6-1.6-1.6
                  h-3.7C178.2,141.4,177.5,142.2,177.5,143.1z M211.2,98.6h-27.5c-2.7,0-4.8,2.2-4.8,4.8v26.4c0,2.7,2.2,4.8,4.8,4.8h27.5
                  c2.7,0,4.8-2.2,4.8-4.8v-26.4C216,100.7,213.9,98.6,211.2,98.6z M220.6,244.3v9.6c0,1.1,0.9,2,2,2h9.6c1.1,0,2-0.9,2-2v-9.6
                  c0-1.1-0.9-2-2-2h-9.6C221.5,242.4,220.6,243.2,220.6,244.3z M143.3,177.7h22c3,0,5.5-2.4,5.5-5.5v-23.1c0-3-2.4-5.5-5.5-5.5h-22
                  c-3,0-5.5,2.4-5.5,5.5v23.1C137.8,175.3,140.2,177.7,143.3,177.7z M167.2,136.9c0.9,0,1.6-0.7,1.6-1.6v-11.5c0-0.9-0.7-1.6-1.6-1.6
                  h-11.9c-0.9,0-1.6,0.7-1.6,1.6v11.5c0,0.9,0.7,1.6,1.6,1.6H167.2z M228.5,280.7v4.9c0,0.5,0.4,0.9,0.9,0.9h4.9
                  c0.5,0,0.9-0.4,0.9-0.9v-4.9c0-0.5-0.4-0.9-0.9-0.9h-4.9C228.9,279.8,228.5,280.2,228.5,280.7z M232.8,124.3h-6.3
                  c-0.8,0-1.4,0.6-1.4,1.4v6c0,0.8,0.6,1.4,1.4,1.4h6.3c0.8,0,1.4-0.6,1.4-1.4v-6C234.2,125,233.6,124.3,232.8,124.3z M255.5,119.6
                  c0.8,0,1.4-0.6,1.4-1.4v-3.8c0-0.8-0.6-1.4-1.4-1.4h-4c-0.8,0-1.4,0.6-1.4,1.4v3.8c0,0.8,0.6,1.4,1.4,1.4H255.5z M285,155.9
                  c0.8,0,1.4-0.6,1.4-1.4v-3.8c0-0.8-0.6-1.4-1.4-1.4h-4c-0.8,0-1.4,0.6-1.4,1.4v3.8c0,0.8,0.6,1.4,1.4,1.4H285z M261.4,172.7V191
                  c0,2.3,1.8,4.1,4.1,4.1h19.1c2.3,0,4.1-1.8,4.1-4.1v-18.2c0-2.3-1.8-4.1-4.1-4.1h-19.1C263.2,168.6,261.4,170.5,261.4,172.7z
                   M250.1,274.4c0,1.1,0.9,2,2,2h5.1c1.1,0,2-0.9,2-2v-6.2c0-1.1-0.9-2-2-2h-5.1c-1.1,0-2,0.9-2,2V274.4z M129.2,196.5h10.3
                  c0.9,0,1.6-0.7,1.6-1.6V185c0-0.9-0.7-1.6-1.6-1.6h-10.3c-0.9,0-1.6,0.7-1.6,1.6v9.9C127.6,195.8,128.3,196.5,129.2,196.5z
                   M172.1,183.4c-0.9,0-1.6,0.7-1.6,1.6v4.6c0,0.9,0.7,1.6,1.6,1.6h4.9c0.9,0,1.6-0.7,1.6-1.6V185c0-0.9-0.7-1.6-1.6-1.6H172.1z
                   M243.1,71.6c-35.8,0-68.3,14.6-91.6,38.2c18.8-16.2,43.2-26,70-26c2.2,0,4.3,0.1,6.4,0.2h-3.4c-0.9,0-1.6,0.7-1.6,1.6v11
                  c0,0.9,0.7,1.6,1.6,1.6h11.5c0.9,0,1.6-0.7,1.6-1.6v-11c0-0.2-0.1-0.5-0.1-0.7c4.7,0.7,9.3,1.7,13.7,3v5.3c0,0.9,0.7,1.6,1.6,1.6
                  h5.8c0.9,0,1.6-0.7,1.6-1.6v-2.2c5.2,2,10.2,4.4,15,7.2h-7c-1.9,0-3.4,1.5-3.4,3.4V130c0,1.9,1.5,3.4,3.4,3.4h29.4
                  c1.9,0,3.4-1.5,3.4-3.4v-10.8c5.8,6.4,10.8,13.5,14.9,21.1h28.6c4.8,0,8.6,3.9,8.6,8.6v40.6c0,4.8-3.9,8.6-8.6,8.6h-16
                  c-0.5,8.2-2,16.2-4.3,23.8h-6.7c-2.3,0-4.1,1.8-4.1,4.1v20.3c-2.1,3.5-4.4,6.8-6.8,10v-4c0-0.5-0.4-0.9-0.9-0.9h-4.9
                  c-0.5,0-0.9,0.4-0.9,0.9v4.9c0,0.5,0.4,0.9,0.9,0.9h4.4c-1.9,2.4-3.9,4.6-5.9,6.8h-27c-2.3,0-4.1,1.8-4.1,4.1v18.7
                  c-14.1,6.8-30,10.7-46.7,10.7c-0.3,0-0.6,0-0.9,0c0,0,0-0.1,0-0.1v-28.1c0-2.3-1.8-4.1-4.1-4.1h-29.3c-2.3,0-4.1,1.8-4.1,4.1v21.2
                  c-9.1-3.5-17.7-8.2-25.4-13.9h11.9c1.8,0,3.3-1.5,3.3-3.3v-12.7c0-1.8-1.5-3.3-3.3-3.3h-12.7c-1.8,0-3.3,1.5-3.3,3.3v12.7
                  c0,0,0,0.1,0,0.1c-23-18.8-38-46.8-39.4-78.5c-0.1,1.6-0.1,3.1-0.1,4.7c0,17.2,3.4,33.5,9.4,48.5c0,0,0,0,0,0c0,0,0,0,0,0
                  c1.2,2.9,2.5,5.8,3.9,8.7c0,0,0,0,0,0c1.4,2.8,2.9,5.6,4.5,8.3c0,0,0,0,0,0c1.6,2.7,3.3,5.3,5.1,7.9c0,0,0,0.1,0.1,0.1
                  c1.8,2.5,3.6,5,5.6,7.4c0,0,0.1,0.1,0.1,0.1c1.9,2.4,3.9,4.7,6,7c0,0.1,0.1,0.1,0.1,0.2c2.1,2.2,4.2,4.4,6.5,6.4
                  c0.1,0.1,0.1,0.1,0.2,0.2c2.2,2,4.5,4,6.9,5.9c0.1,0.1,0.2,0.1,0.3,0.2c1.2,0.9,2.4,1.9,3.6,2.8c0,0,0.1,0.1,0.1,0.1
                  c1.2,0.9,2.3,1.7,3.5,2.5c0.1,0.1,0.2,0.2,0.3,0.2c1.2,0.8,2.5,1.7,3.7,2.4c0.1,0.1,0.2,0.1,0.3,0.2c1.2,0.7,2.4,1.5,3.6,2.2
                  c0.1,0.1,0.3,0.2,0.4,0.2c1.3,0.7,2.5,1.4,3.8,2.1c0.2,0.1,0.3,0.2,0.5,0.3c1.2,0.6,2.4,1.2,3.6,1.8c0.2,0.1,0.3,0.2,0.5,0.2
                  c1.3,0.6,2.6,1.2,3.9,1.8c0.2,0.1,0.4,0.2,0.6,0.3c1.2,0.5,2.4,1,3.6,1.5c0.2,0.1,0.3,0.1,0.5,0.2c1.3,0.5,2.7,1,4,1.5
                  c0.3,0.1,0.5,0.2,0.8,0.3c1.2,0.4,2.5,0.9,3.7,1.2c0.2,0.1,0.3,0.1,0.5,0.2c1.4,0.4,2.7,0.8,4.1,1.2c0.3,0.1,0.6,0.2,0.9,0.2
                  c1.3,0.3,2.5,0.7,3.8,1c0.2,0,0.3,0.1,0.5,0.1c1.4,0.3,2.8,0.6,4.2,0.9c0.3,0.1,0.7,0.1,1,0.2c1.3,0.3,2.6,0.5,4,0.7
                  c0.1,0,0.3,0,0.4,0.1c1.4,0.2,2.9,0.4,4.3,0.6c0.3,0,0.7,0.1,1,0.1c1.4,0.2,2.8,0.3,4.2,0.4c0.1,0,0.2,0,0.2,0
                  c1.5,0.1,2.9,0.2,4.4,0.3c0.4,0,0.7,0,1.1,0c1.5,0.1,3,0.1,4.5,0.1s3,0,4.5-0.1c0.4,0,0.7,0,1.1,0c1.5-0.1,3-0.1,4.4-0.3
                  c0.1,0,0.2,0,0.2,0c1.4-0.1,2.8-0.2,4.2-0.4c0.3,0,0.7-0.1,1-0.1c1.4-0.2,2.9-0.4,4.3-0.6c0.1,0,0.3,0,0.4-0.1
                  c1.3-0.2,2.7-0.4,4-0.7c0.3-0.1,0.7-0.1,1-0.2c1.4-0.3,2.8-0.6,4.2-0.9c0.2,0,0.3-0.1,0.5-0.1c1.3-0.3,2.6-0.6,3.8-1
                  c0.3-0.1,0.6-0.2,0.9-0.2c1.4-0.4,2.8-0.8,4.1-1.2c0.2-0.1,0.3-0.1,0.5-0.2c1.2-0.4,2.5-0.8,3.7-1.2c0.3-0.1,0.5-0.2,0.8-0.3
                  c1.4-0.5,2.7-1,4-1.5c0.2-0.1,0.3-0.1,0.5-0.2c1.2-0.5,2.4-1,3.6-1.5c0.2-0.1,0.4-0.2,0.6-0.3c1.3-0.6,2.6-1.2,3.9-1.8
                  c0.2-0.1,0.3-0.2,0.5-0.2c1.2-0.6,2.4-1.2,3.6-1.8c0.2-0.1,0.3-0.2,0.5-0.3c1.3-0.7,2.6-1.4,3.8-2.1c0.1-0.1,0.3-0.2,0.4-0.2
                  c1.2-0.7,2.4-1.4,3.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2c1.3-0.8,2.5-1.6,3.7-2.4c0.1-0.1,0.2-0.2,0.3-0.2c1.2-0.8,2.4-1.7,3.5-2.5
                  c0,0,0.1-0.1,0.1-0.1c1.2-0.9,2.4-1.8,3.6-2.8c0.1-0.1,0.2-0.1,0.3-0.2c2.4-1.9,4.7-3.9,6.9-5.9c0.1-0.1,0.1-0.1,0.2-0.2
                  c2.2-2.1,4.4-4.2,6.5-6.4c0-0.1,0.1-0.1,0.1-0.2c2.1-2.2,4.1-4.6,6-6.9c0,0,0.1-0.1,0.1-0.1c1.9-2.4,3.8-4.9,5.6-7.4
                  c0,0,0-0.1,0.1-0.1c1.8-2.6,3.5-5.2,5.1-7.9c0,0,0,0,0,0c1.6-2.7,3.1-5.5,4.5-8.3c0,0,0,0,0,0c8.5-17.2,13.3-36.6,13.3-57.2
                  C372.1,129.3,314.4,71.6,243.1,71.6z M250.1,156.3c0,0.9,0.7,1.6,1.6,1.6H262c0.9,0,1.6-0.7,1.6-1.6v-9.9c0-0.9-0.7-1.6-1.6-1.6
                  h-10.3c-0.9,0-1.6,0.7-1.6,1.6V156.3z M314.5,207.1h-6.3c-0.8,0-1.4,0.6-1.4,1.4v6c0,0.8,0.6,1.4,1.4,1.4h6.3c0.8,0,1.4-0.6,1.4-1.4
                  v-6C315.8,207.8,315.2,207.1,314.5,207.1z"
                />
                <linearGradient
                  id="SVGID_3_"
                  gradientUnits="userSpaceOnUse"
                  x1="206.983"
                  y1="315.151"
                  x2="263.7991"
                  y2="148.6041"
                >
                  <stop offset="0" style="stop-color: #184fb4" />
                  <stop offset="0.2136" style="stop-color: #1b58b7" />
                  <stop offset="0.5575" style="stop-color: #226fc1" />
                  <stop offset="0.9867" style="stop-color: #2f96d0" />
                  <stop offset="1" style="stop-color: #2f97d1" />
                </linearGradient>
                <path
                  class="st3"
                  d="M203.8,243.5c0.5,0,0.9,0.4,0.9,0.9v4.9c0,0.5-0.4,0.9-0.9,0.9h-4.9c-0.5,0-0.9-0.4-0.9-0.9v-4.9
                  c0-0.5,0.4-0.9,0.9-0.9H203.8z M229.5,286.6h4.9c0.5,0,0.9-0.4,0.9-0.9v-4.9c0-0.5-0.4-0.9-0.9-0.9h-4.9c-0.5,0-0.9,0.4-0.9,0.9v4.9
                  C228.5,286.2,228.9,286.6,229.5,286.6z M234.2,254v-9.6c0-1.1-0.9-2-2-2h-9.6c-1.1,0-2,0.9-2,2v9.6c0,1.1,0.9,2,2,2h9.6
                  C233.3,256,234.2,255.1,234.2,254z M313.6,229.3v17c-2.1,3.5-4.4,6.8-6.8,10v-4c0-0.5-0.4-0.9-0.9-0.9h-4.9c-0.5,0-0.9,0.4-0.9,0.9
                  v4.9c0,0.5,0.4,0.9,0.9,0.9h4.4c-1.9,2.4-3.9,4.6-5.9,6.8h-27c-2.3,0-4.1,1.8-4.1,4.1v18.7c-14.1,6.8-30,10.7-46.7,10.7
                  c-0.3,0-0.6,0-0.9,0c0,0,0-0.1,0-0.1v-28.1c0-2.3-1.8-4.1-4.1-4.1h-29.3c-2.3,0-4.1,1.8-4.1,4.1v21.2c-9.1-3.5-17.7-8.2-25.4-13.9
                  h11.9c1.8,0,3.3-1.5,3.3-3.3v-12.7c0-1.8-1.5-3.3-3.3-3.3h-12.7c-1.8,0-3.3,1.5-3.3,3.3v12.7c0,0,0,0.1,0,0.1
                  c-23-18.8-38-46.8-39.4-78.5c-0.1,1.6-0.1,3.1-0.1,4.7c0,17.2,3.4,33.5,9.4,48.5c0,0,0,0,0,0c0,0,0,0,0,0c1.2,2.9,2.5,5.8,3.9,8.7
                  c0,0,0,0,0,0c1.4,2.8,2.9,5.6,4.5,8.3c0,0,0,0,0,0c1.6,2.7,3.3,5.3,5.1,7.9c0,0,0,0.1,0.1,0.1c1.8,2.5,3.6,5,5.6,7.4
                  c0,0,0.1,0.1,0.1,0.1c1.9,2.4,3.9,4.7,6,7c0,0.1,0.1,0.1,0.1,0.2c2.1,2.2,4.2,4.4,6.5,6.4c0.1,0.1,0.1,0.1,0.2,0.2
                  c2.2,2,4.5,4,6.9,5.9c0.1,0.1,0.2,0.1,0.3,0.2c1.2,0.9,2.4,1.9,3.6,2.8c0,0,0.1,0.1,0.1,0.1c1.2,0.9,2.3,1.7,3.5,2.5
                  c0.1,0.1,0.2,0.2,0.3,0.2c1.2,0.8,2.5,1.7,3.7,2.4c0.1,0.1,0.2,0.1,0.3,0.2c1.2,0.7,2.4,1.5,3.6,2.2c0.1,0.1,0.3,0.2,0.4,0.2
                  c1.3,0.7,2.5,1.4,3.8,2.1c0.2,0.1,0.3,0.2,0.5,0.3c1.2,0.6,2.4,1.2,3.6,1.8c0.2,0.1,0.3,0.2,0.5,0.2c1.3,0.6,2.6,1.2,3.9,1.8
                  c0.2,0.1,0.4,0.2,0.6,0.3c1.2,0.5,2.4,1,3.6,1.5c0.2,0.1,0.3,0.1,0.5,0.2c1.3,0.5,2.7,1,4,1.5c0.3,0.1,0.5,0.2,0.8,0.3
                  c1.2,0.4,2.5,0.9,3.7,1.2c0.2,0.1,0.3,0.1,0.5,0.2c1.4,0.4,2.7,0.8,4.1,1.2c0.3,0.1,0.6,0.2,0.9,0.2c1.3,0.3,2.5,0.7,3.8,1
                  c0.2,0,0.3,0.1,0.5,0.1c1.4,0.3,2.8,0.6,4.2,0.9c0.3,0.1,0.7,0.1,1,0.2c1.3,0.3,2.6,0.5,4,0.7c0.1,0,0.3,0,0.4,0.1
                  c1.4,0.2,2.9,0.4,4.3,0.6c0.3,0,0.7,0.1,1,0.1c1.4,0.2,2.8,0.3,4.2,0.4c0.1,0,0.2,0,0.2,0c1.5,0.1,2.9,0.2,4.4,0.3
                  c0.4,0,0.7,0,1.1,0c1.5,0.1,3,0.1,4.5,0.1s3,0,4.5-0.1c0.4,0,0.7,0,1.1,0c1.5-0.1,3-0.1,4.4-0.3c0.1,0,0.2,0,0.2,0
                  c1.4-0.1,2.8-0.2,4.2-0.4c0.3,0,0.7-0.1,1-0.1c1.4-0.2,2.9-0.4,4.3-0.6c0.1,0,0.3,0,0.4-0.1c1.3-0.2,2.7-0.4,4-0.7
                  c0.3-0.1,0.7-0.1,1-0.2c1.4-0.3,2.8-0.6,4.2-0.9c0.2,0,0.3-0.1,0.5-0.1c1.3-0.3,2.6-0.6,3.8-1c0.3-0.1,0.6-0.2,0.9-0.2
                  c1.4-0.4,2.8-0.8,4.1-1.2c0.2-0.1,0.3-0.1,0.5-0.2c1.2-0.4,2.5-0.8,3.7-1.2c0.3-0.1,0.5-0.2,0.8-0.3c1.4-0.5,2.7-1,4-1.5
                  c0.2-0.1,0.3-0.1,0.5-0.2c1.2-0.5,2.4-1,3.6-1.5c0.2-0.1,0.4-0.2,0.6-0.3c1.3-0.6,2.6-1.2,3.9-1.8c0.2-0.1,0.3-0.2,0.5-0.2
                  c1.2-0.6,2.4-1.2,3.6-1.8c0.2-0.1,0.3-0.2,0.5-0.3c1.3-0.7,2.6-1.4,3.8-2.1c0.1-0.1,0.3-0.2,0.4-0.2c1.2-0.7,2.4-1.4,3.6-2.2
                  c0.1-0.1,0.2-0.1,0.3-0.2c1.3-0.8,2.5-1.6,3.7-2.4c0.1-0.1,0.2-0.2,0.3-0.2c1.2-0.8,2.4-1.7,3.5-2.5c0,0,0.1-0.1,0.1-0.1
                  c1.2-0.9,2.4-1.8,3.6-2.8c0.1-0.1,0.2-0.1,0.3-0.2c2.4-1.9,4.7-3.9,6.9-5.9c0.1-0.1,0.1-0.1,0.2-0.2c2.2-2.1,4.4-4.2,6.5-6.4
                  c0-0.1,0.1-0.1,0.1-0.2c2.1-2.2,4.1-4.6,6-6.9c0,0,0.1-0.1,0.1-0.1c1.9-2.4,3.8-4.9,5.6-7.4c0,0,0-0.1,0.1-0.1
                  c1.8-2.6,3.5-5.2,5.1-7.9c0,0,0,0,0,0c1.6-2.7,3.1-5.5,4.5-8.3c0,0,0,0,0,0c8.5-17.2,13.3-36.6,13.3-57.2c0-2.5-0.1-5-0.2-7.5
                  C355.4,209,335.6,221.4,313.6,229.3z M252.1,276.4h5.1c1.1,0,2-0.9,2-2v-6.2c0-1.1-0.9-2-2-2h-5.1c-1.1,0-2,0.9-2,2v6.2
                  C250.1,275.5,251,276.4,252.1,276.4z"
                />
                <circle class="st4" cx="1336" cy="139.7" r="24.4" />
                <linearGradient
                  id="SVGID_4_"
                  gradientUnits="userSpaceOnUse"
                  x1="134.3913"
                  y1="197.7675"
                  x2="348.631"
                  y2="197.7675"
                >
                  <stop offset="0" style="stop-color: #febd01" />
                  <stop offset="0.1645" style="stop-color: #febd01" />
                  <stop offset="0.1904" style="stop-color: #febd01" />
                  <stop offset="0.2034" style="stop-color: #fbbe02" />
                  <stop offset="0.214" style="stop-color: #f1c007" />
                  <stop offset="0.2238" style="stop-color: #e0c40e" />
                  <stop offset="0.2331" style="stop-color: #c7c917" />
                  <stop offset="0.2421" style="stop-color: #a8d024" />
                  <stop offset="0.2508" style="stop-color: #82d934" />
                  <stop offset="0.2591" style="stop-color: #56e246" />
                  <stop offset="0.2611" style="stop-color: #4ae54b" />
                  <stop offset="0.4793" style="stop-color: #4ae54b" />
                  <stop offset="0.4879" style="stop-color: #6fbb42" />
                  <stop offset="0.5062" style="stop-color: #b96931" />
                  <stop offset="0.5191" style="stop-color: #e73526" />
                  <stop offset="0.5254" style="stop-color: #f92122" />
                  <stop offset="0.7275" style="stop-color: #f92122" />
                  <stop offset="0.7355" style="stop-color: #fa2d1f" />
                  <stop offset="0.7496" style="stop-color: #fb4b16" />
                  <stop offset="0.7683" style="stop-color: #fe7d08" />
                  <stop offset="0.7779" style="stop-color: #ff9900" />
                  <stop offset="1" style="stop-color: #fe9900" />
                </linearGradient>
                <path
                  class="st5"
                  d="M342,146.4h-34.3c-3.6,0-6.6,3-6.6,6.6v32.9c0,0.9,0.2,1.8,0.6,2.6l-14.6,14.6c-0.2,0-0.4,0-0.6,0h-34.3
                  c-0.2,0-0.3,0-0.5,0L237,188.4c0.3-0.8,0.5-1.7,0.5-2.6V153c0-3.6-3-6.6-6.6-6.6h-34.3c-3.6,0-6.6,3-6.6,6.6v32.9
                  c0,0.9,0.2,1.8,0.6,2.6l-14.6,14.6c-0.2,0-0.4,0-0.6,0H141c-3.6,0-6.6,3-6.6,6.6v32.9c0,3.6,3,6.6,6.6,6.6h34.3c3.6,0,6.6-3,6.6-6.6
                  v-32.9c0-1-0.2-2-0.7-2.9l14.4-14.4c0.3,0,0.6,0.1,0.9,0.1h34.3c0.3,0,0.6,0,1-0.1l14.4,14.4c-0.4,0.9-0.7,1.9-0.7,2.9v32.9
                  c0,3.6,3,6.6,6.6,6.6h34.3c3.6,0,6.6-3,6.6-6.6v-32.9c0-1-0.2-2-0.7-2.9l14.4-14.4c0.3,0,0.6,0.1,0.9,0.1H342c3.6,0,6.6-3,6.6-6.6
                  V153C348.6,149.3,345.7,146.4,342,146.4z"
                />
                <g>
                  <path
                    class="st6"
                    d="M486.6,157.3h-5.8c-37.2,0-67.4,30.2-67.4,67.4v4.6c0,37.2,30.2,67.4,67.4,67.4h5.8
                      c37.2,0,67.4-30.2,67.4-67.4v-4.6C554,187.5,523.8,157.3,486.6,157.3z M529.1,230.8c0,23-18.6,41.6-41.6,41.6h-6.3
                      c-23,0-41.6-18.6-41.6-41.6v-6.3c0-23,18.6-41.6,41.6-41.6h6.3c23,0,41.6,18.6,41.6,41.6V230.8z"
                  />
                  <path
                    class="st6"
                    d="M679.3,160.7c-7.2,0-13,5.8-13,13v73.2l-62.1-77.8c-0.6-0.7-1.2-1.4-1.9-2c-1.9-3.1-5.3-5.2-9.3-5.2h-0.7
                      c-2.3-0.4-4.7-0.2-6.8,0.5c-1.3,0.4-2.5,1.1-3.6,1.9c0,0-0.1,0-0.1,0.1c-0.4,0.3-0.8,0.7-1.1,1.1c-1.8,1.9-2.9,4.5-2.9,7.4v110.9
                      c0,6,4.9,10.9,10.9,10.9h4.3c6,0,10.9-4.9,10.9-10.9v-75.1l63.2,79.7c1.7,2.1,3.8,3.7,6.2,4.7c1.8,1,3.9,1.5,6.1,1.5
                      c3.8,0,7.1-1.6,9.5-4.1c1-1.1,1.8-2.2,2.3-3.4c0.8-1.7,1.2-3.5,1.2-5.5V173.7C692.4,166.5,686.5,160.7,679.3,160.7z"
                  />
                  <path
                    class="st6"
                    d="M776.7,160.9c-0.5-0.1-1-0.2-1.5-0.2h-50.2h-1.6H723c-3.8,0-6.8,3-6.8,6.8v0.2c0,0,0,0,0,0c0,0,0,0,0,0v72.3
                      v0.2v47.1c0,3.9,3.2,7.1,7.1,7.1h1.6c3.9,0,7.1-3.2,7.1-7.1v-40.3h36.3c0.4,0,0.8,0,1.1-0.1c8.4-0.7,46.5-5.9,46.5-43.2
                      C816,167.7,785.9,161.8,776.7,160.9z M767.9,233.3h-35.8v-58.7h41.8c7,0.9,27.4,6.6,27.4,27S788.9,231,767.9,233.3z"
                  />
                  <path
                    class="st6"
                    d="M894.3,163.7c0,0-1.2-5.2-8-5.2c-6.8,0-9.1,2.3-10,4c0,0,0,0,0,0c-0.2,0.2-0.3,0.5-0.4,0.8l-54.9,121.9
                      c-1.6,3.6,0,7.8,3.6,9.4c3.6,1.6,7.8,0,9.4-3.6l14.7-32.7h72.6l14.7,32.7c1.6,3.6,5.8,5.2,9.4,3.6c3.6-1.6,5.2-5.8,3.6-9.4
                      L894.3,163.7z M854.7,244.6l30.2-67.1l30.1,67.1H854.7z"
                  />
                  <path
                    class="st6"
                    d="M1510.6,279.8h-75.4v-45.4h66.3c4.1,0,7.4-3.3,7.4-7.4s-3.3-7.4-7.4-7.4h-66.3v-45.4h74.3
                      c4.1,0,7.4-3.3,7.4-7.4s-3.3-7.4-7.4-7.4h-81.7c-4.1,0-7.4,3.3-7.4,7.4v120.2c0,4.1,3.3,7.4,7.4,7.4h82.8c4.1,0,7.4-3.3,7.4-7.4
                      C1518,283.1,1514.7,279.8,1510.6,279.8z"
                  />
                  <path
                    class="st6"
                    d="M1034.9,221.9c-32.9-6.8-43.1-12.5-44.2-26.1c-0.9-10.2,4.5-23.8,28.4-23.8c21.5,0,31.4,9.9,33.9,11.2l0,0
                      c1.2,0.8,2.6,1.3,4.1,1.3c4.1,0,7.4-3.3,7.4-7.4c0-1.9-0.7-3.5-1.8-4.8c0,0,0,0,0,0c-0.5-0.5-1-1-1.6-1.4
                      c-5.5-4.4-19.8-12.5-43-12.5c-26.1,0-37.4,14.7-42,28.4s1.1,29.5,14.7,37.4c13.6,7.9,43.1,10.2,53.3,17
                      c10.2,6.8,15.9,18.1,5.7,31.8c-10.2,13.6-43.4,14-65.9-6h0c-1.3-1.2-3-1.9-5-1.9c-4.1,0-7.4,3.3-7.4,7.4c0,2.1,0.9,4,2.3,5.3
                      c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0,0,0,0c4.3,3.8,23.2,17.6,49.5,17.6c27.2,0,40.3-12.3,45.4-28.4
                      C1074.6,249.2,1065.4,228.3,1034.9,221.9z"
                  />
                  <path
                    class="st6"
                    d="M1237.3,159.6c-4.1,0-7.4,3.3-7.4,7.4v120.2c0,4.1,3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4V166.9
                      C1244.7,162.9,1241.4,159.6,1237.3,159.6z"
                  />
                  <path
                    class="st6"
                    d="M1158.5,221.9c-32.9-6.8-43.1-12.5-44.2-26.1c-0.9-10.2,4.5-23.8,28.4-23.8c21.5,0,31.4,9.9,33.9,11.2h0
                      c1.2,0.8,2.6,1.3,4.1,1.3c4.1,0,7.4-3.3,7.4-7.4c0-1.9-0.7-3.5-1.8-4.8c0,0,0,0,0,0c-0.5-0.5-1-1-1.6-1.4
                      c-5.5-4.4-19.8-12.5-43-12.5c-26.1,0-37.4,14.7-42,28.4c-4.5,13.6,1.1,29.5,14.7,37.4s43.1,10.2,53.3,17
                      c10.2,6.8,15.9,18.1,5.7,31.8c-10.2,13.6-43.4,14-65.9-6h0c-1.3-1.2-3-1.9-5-1.9c-4.1,0-7.4,3.3-7.4,7.4c0,2.1,0.9,4,2.3,5.3
                      c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0,0,0,0c4.3,3.8,23.2,17.6,49.5,17.6c27.2,0,40.3-12.3,45.4-28.4
                      C1198.2,249.2,1189,228.3,1158.5,221.9z"
                  />
                </g>
                <g>
                  <linearGradient
                    id="SVGID_5_"
                    gradientUnits="userSpaceOnUse"
                    x1="483.6958"
                    y1="153.8982"
                    x2="483.6958"
                    y2="293.3932"
                  >
                    <stop offset="0" style="stop-color: #2f98d2" />
                    <stop offset="1" style="stop-color: #1b52ac" />
                  </linearGradient>
                  <path
                    class="st7"
                    d="M486.6,153.9h-5.8c-37.2,0-67.4,30.2-67.4,67.4v4.6c0,37.2,30.2,67.4,67.4,67.4h5.8
                      c37.2,0,67.4-30.2,67.4-67.4v-4.6C554,184.1,523.8,153.9,486.6,153.9z M529.1,227.4c0,23-18.6,41.6-41.6,41.6h-6.3
                      c-23,0-41.6-18.6-41.6-41.6V221c0-23,18.6-41.6,41.6-41.6h6.3c23,0,41.6,18.6,41.6,41.6V227.4z"
                  />
                  <linearGradient
                    id="SVGID_6_"
                    gradientUnits="userSpaceOnUse"
                    x1="635.0989"
                    y1="157.3005"
                    x2="635.0989"
                    y2="291.125"
                  >
                    <stop offset="0" style="stop-color: #2f98d2" />
                    <stop offset="1" style="stop-color: #1b52ac" />
                  </linearGradient>
                  <path
                    class="st8"
                    d="M679.3,157.3c-7.2,0-13,5.8-13,13v73.2l-62.1-77.8c-0.6-0.7-1.2-1.4-1.9-2c-1.9-3.1-5.3-5.2-9.3-5.2h-0.7
                      c-2.3-0.4-4.7-0.2-6.8,0.5c-1.3,0.4-2.5,1.1-3.6,1.9c0,0-0.1,0-0.1,0.1c-0.4,0.3-0.8,0.7-1.1,1.1c-1.8,1.9-2.9,4.5-2.9,7.4v110.9
                      c0,6,4.9,10.9,10.9,10.9h4.3c6,0,10.9-4.9,10.9-10.9v-75.1l63.2,79.7c1.7,2.1,3.8,3.7,6.2,4.7c1.8,1,3.9,1.5,6.1,1.5
                      c3.8,0,7.1-1.6,9.5-4.1c1-1.1,1.8-2.2,2.3-3.4c0.8-1.7,1.2-3.5,1.2-5.5V170.3C692.4,163.1,686.5,157.3,679.3,157.3z"
                  />
                  <linearGradient
                    id="SVGID_7_"
                    gradientUnits="userSpaceOnUse"
                    x1="766.0881"
                    y1="157.3005"
                    x2="766.0881"
                    y2="291.125"
                  >
                    <stop offset="0" style="stop-color: #2f98d2" />
                    <stop offset="1" style="stop-color: #1b52ac" />
                  </linearGradient>
                  <path
                    class="st9"
                    d="M776.7,157.5c-0.5-0.1-1-0.2-1.5-0.2h-50.2h-1.6H723c-3.8,0-6.8,3-6.8,6.8v0.2c0,0,0,0,0,0c0,0,0,0,0,0v72.3
                      v0.2V284c0,3.9,3.2,7.1,7.1,7.1h1.6c3.9,0,7.1-3.2,7.1-7.1v-40.3h36.3c0.4,0,0.8,0,1.1-0.1c8.4-0.7,46.5-5.9,46.5-43.2
                      C816,164.3,785.9,158.4,776.7,157.5z M767.9,229.9h-35.8v-58.7h41.8c7,0.9,27.4,6.6,27.4,27S788.9,227.6,767.9,229.9z"
                  />
                  <linearGradient
                    id="SVGID_8_"
                    gradientUnits="userSpaceOnUse"
                    x1="884.8597"
                    y1="155.0323"
                    x2="884.8597"
                    y2="291.7119"
                  >
                    <stop offset="0" style="stop-color: #2f98d2" />
                    <stop offset="1" style="stop-color: #1b52ac" />
                  </linearGradient>
                  <path
                    class="st10"
                    d="M894.3,160.3c0,0-1.2-5.2-8-5.2c-6.8,0-9.1,2.3-10,4c0,0,0,0,0,0c-0.2,0.2-0.3,0.5-0.4,0.8l-54.9,121.9
                      c-1.6,3.6,0,7.8,3.6,9.4c3.6,1.6,7.8,0,9.4-3.6l14.7-32.7h72.6l14.7,32.7c1.6,3.6,5.8,5.2,9.4,3.6c3.6-1.6,5.2-5.8,3.6-9.4
                      L894.3,160.3z M854.7,241.2l30.2-67.1l30.1,67.1H854.7z"
                  />
                  <linearGradient
                    id="SVGID_9_"
                    gradientUnits="userSpaceOnUse"
                    x1="1469.2335"
                    y1="156.1664"
                    x2="1469.2335"
                    y2="291.125"
                  >
                    <stop offset="0" style="stop-color: #2f98d2" />
                    <stop offset="1" style="stop-color: #1b52ac" />
                  </linearGradient>
                  <path
                    class="st11"
                    d="M1510.6,276.4h-75.4V231h66.3c4.1,0,7.4-3.3,7.4-7.4s-3.3-7.4-7.4-7.4h-66.3v-45.4h74.3
                      c4.1,0,7.4-3.3,7.4-7.4s-3.3-7.4-7.4-7.4h-81.7c-4.1,0-7.4,3.3-7.4,7.4v120.2c0,4.1,3.3,7.4,7.4,7.4h82.8c4.1,0,7.4-3.3,7.4-7.4
                      S1514.7,276.4,1510.6,276.4z"
                  />
                  <linearGradient
                    id="SVGID_10_"
                    gradientUnits="userSpaceOnUse"
                    x1="1020.9177"
                    y1="155.0323"
                    x2="1020.9177"
                    y2="292.2591"
                  >
                    <stop offset="0" style="stop-color: #2f98d2" />
                    <stop offset="1" style="stop-color: #1b52ac" />
                  </linearGradient>
                  <path
                    class="st12"
                    d="M1034.9,218.5c-32.9-6.8-43.1-12.5-44.2-26.1c-0.9-10.2,4.5-23.8,28.4-23.8c21.5,0,31.4,9.9,33.9,11.2l0,0
                      c1.2,0.8,2.6,1.3,4.1,1.3c4.1,0,7.4-3.3,7.4-7.4c0-1.9-0.7-3.5-1.8-4.8c0,0,0,0,0,0c-0.5-0.5-1-1-1.6-1.4
                      c-5.5-4.4-19.8-12.5-43-12.5c-26.1,0-37.4,14.7-42,28.4c-4.5,13.6,1.1,29.5,14.7,37.4c13.6,7.9,43.1,10.2,53.3,17
                      c10.2,6.8,15.9,18.1,5.7,31.8c-10.2,13.6-43.4,14-65.9-6h0c-1.3-1.2-3-1.9-5-1.9c-4.1,0-7.4,3.3-7.4,7.4c0,2.1,0.9,4,2.3,5.3
                      c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0,0,0,0c4.3,3.8,23.2,17.6,49.5,17.6c27.2,0,40.3-12.3,45.4-28.4
                      C1074.6,245.8,1065.4,224.9,1034.9,218.5z"
                  />
                  <linearGradient
                    id="SVGID_11_"
                    gradientUnits="userSpaceOnUse"
                    x1="1237.309"
                    y1="156.1664"
                    x2="1237.309"
                    y2="291.125"
                  >
                    <stop offset="0" style="stop-color: #2f98d2" />
                    <stop offset="1" style="stop-color: #1b52ac" />
                  </linearGradient>
                  <path
                    class="st13"
                    d="M1237.3,156.2c-4.1,0-7.4,3.3-7.4,7.4v120.2c0,4.1,3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4V163.5
                      C1244.7,159.5,1241.4,156.2,1237.3,156.2z"
                  />
                  <linearGradient
                    id="SVGID_12_"
                    gradientUnits="userSpaceOnUse"
                    x1="1144.5352"
                    y1="155.0323"
                    x2="1144.5352"
                    y2="292.2591"
                  >
                    <stop offset="0" style="stop-color: #2f98d2" />
                    <stop offset="1" style="stop-color: #1b52ac" />
                  </linearGradient>
                  <path
                    class="st14"
                    d="M1158.5,218.5c-32.9-6.8-43.1-12.5-44.2-26.1c-0.9-10.2,4.5-23.8,28.4-23.8c21.5,0,31.4,9.9,33.9,11.2h0
                      c1.2,0.8,2.6,1.3,4.1,1.3c4.1,0,7.4-3.3,7.4-7.4c0-1.9-0.7-3.5-1.8-4.8c0,0,0,0,0,0c-0.5-0.5-1-1-1.6-1.4
                      c-5.5-4.4-19.8-12.5-43-12.5c-26.1,0-37.4,14.7-42,28.4c-4.5,13.6,1.1,29.5,14.7,37.4s43.1,10.2,53.3,17s15.9,18.1,5.7,31.8
                      c-10.2,13.6-43.4,14-65.9-6h0c-1.3-1.2-3-1.9-5-1.9c-4.1,0-7.4,3.3-7.4,7.4c0,2.1,0.9,4,2.3,5.3c0.1,0.1,0.2,0.2,0.4,0.3
                      c0,0,0,0,0,0c4.3,3.8,23.2,17.6,49.5,17.6c27.2,0,40.3-12.3,45.4-28.4C1198.2,245.8,1189,224.9,1158.5,218.5z"
                  />
                </g>
                <path
                  class="st15"
                  d="M1239,102c11.3,15.2,44.2,63.2,60.1,114.6c15.9,51.5,23.8,80.7,27.2,139.2c2.3-9.4,21.5-86.5,43.1-138
                  c21.5-51.5,53.3-131,106.6-161.4c0,0-22.7,5.8-60.1,45.6c-37.4,39.8-61.2,78.4-81.7,122.8C1324.1,201.4,1291.2,138.2,1239,102z"
                />
                <linearGradient
                  id="SVGID_13_"
                  gradientUnits="userSpaceOnUse"
                  x1="1357.524"
                  y1="55.231"
                  x2="1357.524"
                  y2="345.562"
                >
                  <stop offset="0" style="stop-color: #fde500" />
                  <stop offset="0.2265" style="stop-color: #fdd300" />
                  <stop offset="0.6792" style="stop-color: #fea400" />
                  <stop offset="1" style="stop-color: #ff7f00" />
                </linearGradient>
                <path
                  class="st16"
                  d="M1239,99.5c11.3,14.7,44.2,61.2,60.1,111.1c15.9,49.9,23.8,78.3,27.2,135c2.3-9.1,21.5-83.9,43.1-133.8
                  c21.5-49.9,53.3-127,106.6-156.5c0,0-22.7,5.7-60.1,44.2c-37.4,38.6-61.2,76-81.7,119.1C1324.1,195.9,1291.2,134.6,1239,99.5z"
                />
                <linearGradient
                  id="SVGID_14_"
                  gradientUnits="userSpaceOnUse"
                  x1="1335.9761"
                  y1="113.0704"
                  x2="1335.9761"
                  y2="161.8369"
                >
                  <stop offset="0" style="stop-color: #fd4142" />
                  <stop offset="0.5053" style="stop-color: #f82121" />
                  <stop offset="1" style="stop-color: #f30505" />
                </linearGradient>
                <circle class="st17" cx="1336" cy="137.5" r="24.4" />
                <linearGradient
                  id="SVGID_15_"
                  gradientUnits="userSpaceOnUse"
                  x1="1335.9761"
                  y1="114.8493"
                  x2="1335.9761"
                  y2="143.6913"
                >
                  <stop offset="0" style="stop-color: #ffffff" />
                  <stop
                    offset="1"
                    style="stop-color: #ffffff; stop-opacity: 0"
                  />
                </linearGradient>
                <path
                  class="st18"
                  d="M1357,135.2c0,11.3-42,11.3-42,0s9.4-20.4,21-20.4S1357,124,1357,135.2z"
                />
                <linearGradient
                  id="SVGID_16_"
                  gradientUnits="userSpaceOnUse"
                  x1="175.969"
                  y1="207.5854"
                  x2="196.0173"
                  y2="187.5371"
                >
                  <stop offset="0.2234" style="stop-color: #febd01" />
                  <stop offset="0.6441" style="stop-color: #84da3a" />
                  <stop offset="0.8346" style="stop-color: #52e652" />
                </linearGradient>
                <polygon
                  class="st19"
                  points="193.7,185.3 198.3,189.8 178.2,209.9 173.7,205.3 "
                />
                <linearGradient
                  id="SVGID_17_"
                  gradientUnits="userSpaceOnUse"
                  x1="285.9772"
                  y1="208.7195"
                  x2="306.0255"
                  y2="188.6712"
                >
                  <stop offset="0.269" style="stop-color: #f92122" />
                  <stop offset="0.5991" style="stop-color: #fc7b1c" />
                  <stop offset="0.7665" style="stop-color: #fea41a" />
                </linearGradient>
                <polygon
                  class="st20"
                  points="303.8,186.4 308.3,190.9 288.2,211 283.7,206.5 "
                />
                <linearGradient
                  id="SVGID_18_"
                  gradientUnits="userSpaceOnUse"
                  x1="231.5401"
                  y1="187.5371"
                  x2="251.5885"
                  y2="207.5854"
                >
                  <stop offset="0.1697" style="stop-color: #4ae54b" />
                  <stop offset="0.2702" style="stop-color: #60cc46" />
                  <stop offset="0.4845" style="stop-color: #9a8b38" />
                  <stop offset="0.7934" style="stop-color: #f62523" />
                  <stop offset="0.8037" style="stop-color: #f92122" />
                </linearGradient>
                <polygon
                  class="st21"
                  points="229.3,189.8 233.8,185.3 253.9,205.3 249.3,209.9 "
                />
                <linearGradient
                  id="SVGID_19_"
                  gradientUnits="userSpaceOnUse"
                  x1="243.8079"
                  y1="329.5879"
                  x2="244.8651"
                  y2="269.0184"
                >
                  <stop offset="0" style="stop-color: #1544a0" />
                  <stop offset="1" style="stop-color: #1745a3" />
                </linearGradient>
                <path
                  class="st22"
                  d="M350,272.4c0,0-0.1,0.1-0.1,0.1c-2.1,2.4-4.2,4.7-6.5,6.9c-0.1,0.1-0.1,0.1-0.2,0.2c-2.2,2.2-4.5,4.4-6.9,6.4
                  c-0.1,0.1-0.1,0.1-0.2,0.2c-2.4,2-4.8,4-7.3,5.9c-0.1,0.1-0.2,0.1-0.3,0.2c-1.3,0.9-2.5,1.9-3.8,2.8c0,0-0.1,0.1-0.1,0.1
                  c-1.2,0.9-2.5,1.7-3.8,2.5c-0.1,0.1-0.2,0.2-0.4,0.2c-1.3,0.8-2.6,1.7-4,2.4c-0.1,0.1-0.2,0.1-0.3,0.2c-1.3,0.7-2.5,1.5-3.8,2.2
                  c-0.1,0.1-0.3,0.2-0.4,0.2c-1.3,0.7-2.7,1.4-4.1,2.1c-0.2,0.1-0.3,0.2-0.5,0.3c-1.3,0.6-2.5,1.2-3.8,1.8c-0.2,0.1-0.3,0.2-0.5,0.2
                  c-1.4,0.6-2.8,1.2-4.2,1.8c-0.2,0.1-0.5,0.2-0.7,0.3c-1.3,0.5-2.6,1-3.9,1.5c-0.2,0.1-0.4,0.1-0.5,0.2c-1.4,0.5-2.9,1-4.3,1.5
                  c-0.3,0.1-0.6,0.2-0.8,0.3c-1.3,0.4-2.6,0.8-4,1.2c-0.2,0.1-0.4,0.1-0.5,0.2c-1.5,0.4-2.9,0.8-4.4,1.2c-0.3,0.1-0.6,0.2-1,0.2
                  c-1.4,0.3-2.7,0.7-4.1,1c-0.2,0-0.3,0.1-0.5,0.1c-1.5,0.3-3,0.6-4.5,0.9c-0.3,0.1-0.7,0.1-1,0.2c-1.4,0.3-2.8,0.5-4.3,0.7
                  c-0.1,0-0.3,0-0.4,0.1c-1.5,0.2-3.1,0.4-4.6,0.6c-0.4,0-0.7,0.1-1.1,0.1c-1.5,0.2-3,0.3-4.5,0.4c-0.1,0-0.2,0-0.2,0
                  c-1.6,0.1-3.1,0.2-4.7,0.3c-0.4,0-0.8,0-1.2,0c-1.6,0.1-3.2,0.1-4.8,0.1c-1.6,0-3.2,0-4.8-0.1c-0.4,0-0.8,0-1.2,0
                  c-1.6-0.1-3.2-0.1-4.7-0.3c-0.1,0-0.2,0-0.2,0c-1.5-0.1-3-0.2-4.5-0.4c-0.4,0-0.7-0.1-1.1-0.1c-1.5-0.2-3.1-0.4-4.6-0.6
                  c-0.1,0-0.3,0-0.4-0.1c-1.4-0.2-2.8-0.4-4.3-0.7c-0.3-0.1-0.7-0.1-1-0.2c-1.5-0.3-3-0.6-4.5-0.9c-0.2,0-0.3-0.1-0.5-0.1
                  c-1.4-0.3-2.7-0.6-4.1-1c-0.3-0.1-0.6-0.2-1-0.2c-1.5-0.4-2.9-0.8-4.4-1.2c-0.2-0.1-0.4-0.1-0.5-0.2c-1.3-0.4-2.7-0.8-4-1.2
                  c-0.3-0.1-0.6-0.2-0.8-0.3c-1.4-0.5-2.9-1-4.3-1.5c-0.2-0.1-0.3-0.1-0.5-0.2c-1.3-0.5-2.6-1-3.9-1.5c-0.2-0.1-0.5-0.2-0.7-0.3
                  c-1.4-0.6-2.8-1.2-4.2-1.8c-0.2-0.1-0.3-0.2-0.5-0.2c-1.3-0.6-2.6-1.2-3.8-1.8c-0.2-0.1-0.3-0.2-0.5-0.3c-1.4-0.7-2.7-1.4-4.1-2.1
                  c-0.1-0.1-0.3-0.2-0.4-0.2c-1.3-0.7-2.5-1.4-3.8-2.2c-0.1-0.1-0.2-0.1-0.3-0.2c-1.3-0.8-2.7-1.6-4-2.4c-0.1-0.1-0.2-0.2-0.4-0.2
                  c-1.3-0.8-2.5-1.7-3.8-2.5c0,0-0.1-0.1-0.1-0.1c-1.3-0.9-2.6-1.8-3.8-2.8c-0.1-0.1-0.2-0.1-0.3-0.2c-2.5-1.9-5-3.9-7.3-5.9
                  c-0.1-0.1-0.2-0.1-0.2-0.2c-2.4-2.1-4.7-4.2-6.9-6.4c-0.1-0.1-0.1-0.1-0.2-0.2c-1.2-1.3-2.5-2.5-3.7-3.8
                  c23.4,32.6,61.6,53.9,104.8,53.9c45.3,0,85.1-23.4,108.1-58.7C350.8,271.4,350.4,271.9,350,272.4z"
                />
                <linearGradient
                  id="SVGID_20_"
                  gradientUnits="userSpaceOnUse"
                  x1="324.8679"
                  y1="182.9394"
                  x2="324.8679"
                  y2="146.3719"
                >
                  <stop offset="0" style="stop-color: #ffffff" />
                  <stop
                    offset="1"
                    style="stop-color: #ffffff; stop-opacity: 0"
                  />
                </linearGradient>
                <path
                  class="st23"
                  d="M348.6,168.1V153c0-3.6-3-6.6-6.6-6.6h-34.3c-3.6,0-6.6,3-6.6,6.6v30C310.6,181.6,326.2,178.7,348.6,168.1z"
                />
                <linearGradient
                  id="SVGID_21_"
                  gradientUnits="userSpaceOnUse"
                  x1="269.2967"
                  y1="239.6446"
                  x2="269.2967"
                  y2="203.0771"
                >
                  <stop offset="0" style="stop-color: #ffffff" />
                  <stop
                    offset="1"
                    style="stop-color: #ffffff; stop-opacity: 0"
                  />
                </linearGradient>
                <path
                  class="st24"
                  d="M293.1,224.8v-15.1c0-3.6-3-6.6-6.6-6.6h-34.3c-3.6,0-6.6,3-6.6,6.6v30C255,238.3,270.6,235.4,293.1,224.8z"
                />
                <linearGradient
                  id="SVGID_22_"
                  gradientUnits="userSpaceOnUse"
                  x1="213.7256"
                  y1="182.9394"
                  x2="213.7256"
                  y2="146.3719"
                >
                  <stop offset="0" style="stop-color: #ffffff" />
                  <stop
                    offset="1"
                    style="stop-color: #ffffff; stop-opacity: 0"
                  />
                </linearGradient>
                <path
                  class="st25"
                  d="M237.5,168.1V153c0-3.6-3-6.6-6.6-6.6h-34.3c-3.6,0-6.6,3-6.6,6.6v30C199.4,181.6,215,178.7,237.5,168.1z"
                />
                <linearGradient
                  id="SVGID_23_"
                  gradientUnits="userSpaceOnUse"
                  x1="158.1544"
                  y1="239.6446"
                  x2="158.1544"
                  y2="203.0771"
                >
                  <stop offset="0" style="stop-color: #ffffff" />
                  <stop
                    offset="1"
                    style="stop-color: #ffffff; stop-opacity: 0"
                  />
                </linearGradient>
                <path
                  class="st26"
                  d="M181.9,224.8v-15.1c0-3.6-3-6.6-6.6-6.6H141c-3.6,0-6.6,3-6.6,6.6v30C143.9,238.3,159.5,235.4,181.9,224.8z"
                />
              </svg>
            </div>
          </div>
          <div class="col-lg-7">
            <h1 class="second-section-content2">
              <span class="text-wrapper">
                <span class="letters"
                  >ONPASSIVE Ecosystem Powered by Artificial Intelligence.</span
                >
              </span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-4">
            <div class="content1">
              <div class="horizontal-line"></div>
              <h3 class="content12">We Are</h3>
              <h1 class="content13">COMING SOON!</h1>
              <a
                href="/registration/user?reg={{ userId }}"
                target="_blank"
                rel="noopener"
                class="myButton mt-3"
                >Become A Founder Now</a
              >
            </div>
          </div>
          <div class="col-lg-4">
            <!-- <div class="circle one">  
       </div>-->
            <img
              src="{{
                onPassiveBaseUrl
              }}onpassive(feb-24)/assets/image/icon/globe.png"
              class="glove-icon"
            />
            <div class="circles">
              <div class="circle-1"></div>
              <div class="circle-2"></div>
              <div class="circle-3"></div>
              <div class="circle-4"></div>
              <div class="circle-5"></div>
              <div class="circle-6"></div>
              <div class="circle-7"></div>
              <div class="circle-8"></div>
              <div class="circle-9"></div>
              <div class="circle-10"></div>
              <div class="circle-11"></div>
              <div class="circle-12"></div>
              <div class="circle-13"></div>
              <div class="circle-14"></div>
              <div class="circle-15"></div>
              <div class="circle-16"></div>
              <div class="circle-17"></div>
              <div class="circle-18"></div>
              <div class="circle-19"></div>
              <div class="circle-20"></div>
              <div class="circle-21"></div>
              <div class="circle-22"></div>
              <div class="circle-23"></div>
              <div class="circle-24"></div>
              <div class="circle-25"></div>
              <div class="circle-26"></div>
              <div class="circle-27"></div>
              <div class="circle-28"></div>
              <div class="circle-29"></div>
              <div class="circle-30"></div>
              <div class="circle-31"></div>
              <div class="circle-32"></div>
              <div class="circle-33"></div>
              <div class="circle-34"></div>
              <div class="circle-35"></div>
              <div class="circle-36"></div>
              <div class="circle-37"></div>
              <div class="circle-38"></div>
              <div class="circle-39"></div>
              <div class="circle-40"></div>
              <div class="circle-41"></div>
              <div class="circle-42"></div>
              <div class="circle-43"></div>
              <div class="circle-44"></div>
              <div class="circle-45"></div>
              <div class="circle-46"></div>
              <div class="circle-47"></div>
              <div class="circle-48"></div>
              <div class="circle-49"></div>
              <div class="circle-50"></div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="social-image">
              <ul>
                <li>
                  <a
                    href="https://onpassive.com/blog"
                    target="_blank"
                    rel="noopener"
                    title="ONPASSIVE Blog"
                  >
                    <img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/icon/blog.png"
                      class="blog-icon"
                      alt="ONPASSIVE BLOG"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
                    target="_blank"
                    rel="noopener"
                    title="Facebook"
                  >
                    <img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/icon/fb.png"
                      class="icon"
                      alt="ONPASSIVE  Facebook"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/ONPASSIVE"
                    target="_blank"
                    rel="noopener"
                    title="Twitter"
                  >
                    <img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/icon/twitter.png"
                      class="icon"
                      alt="ONPASSIVE Twitter"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/ONPASSIVE/"
                    target="_blank"
                    rel="noopener"
                    title="Instagram"
                  >
                    <img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/icon/insta.png"
                      class="icon"
                      alt="ONPASSIVE  Instagram"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                    target="_blank"
                    rel="noopener"
                    title="Youtube"
                  >
                    <img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/icon/youtube.png"
                      class="icon"
                      alt="ONPASSIVE YouTube Channel"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
                    target="_blank"
                    rel="noopener"
                    title="LinkedIn"
                  >
                    <img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/icon/in.png"
                      class="icon"
                      alt="ONPASSIVE LinkedIn"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="third-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <h3
            class="third-section-content1"
            data-aos-anchor-placement="center-bottom"
          >
            ABOUT ONPASSIVE
          </h3>
          <p class="third-section-content2" data-aos-easing="ease-in-sine">
            ONPASSIVE has established itself as a leading name in providing
            exceptional AI solutions and services that always adhere to globally
            acknowledged standards and latest technology trends. Through our
            platform, we help organizations attain their business objectives and
            therefore driving them to success.
          </p>
        </div>
        <div class="col-lg-6">
          <div class="video-box">
            <video
              id="my-video"
              class="
                video-js video-size
                w-100
                h-auto
                my-video-dimensions
                shadow
              "
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{ myLinksS3URL }}videos/Launching_Video_1.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="fourth-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 text-center">
          <div class="line"></div>
          <h3 class="fourth-section-content1" data-aos-easing="linear">
            <span class="line"></span>Why You Choose<span class="line"></span>
          </h3>
          <div class="line"></div>
          <p class="fourth-section-content2">
            We transfer any challenge to a digital products through 6 phases in
            1 weeks.
          </p>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-3">
          <div class="card cardh">
            <div class="card-img-top">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(feb-24)/assets/image/icon1.png"
                class="icon1"
                alt="Guaranteed SEO traffic"
              />
            </div>
            <div class="card-title">
              <h4 class="fourth-section-content3">Guranteed Web-Traffic</h4>
            </div>
            <div class="card-body bg-violet">
              <p class="card-text text-white">
                Drive prospects to your site and provide exceptional services
                with the help of automated traffic generator. Simplify the
                problems of uneven traffic flow with the help of ONPASSIVE AI
                tools.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="card cardh">
            <div class="card-img-top">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(feb-24)/assets/image/icon2.png"
                class="icon2"
                alt="ONPASSIVE - End to End Coverage"
              />
            </div>
            <div class="card-title">
              <h4 class="fourth-section-content3">End-To-End Coverage</h4>
            </div>
            <div class="card-body bg-violet">
              <p class="card-text text-white">
                Get the complete business handbook and streamline your business
                strategies when there are roadblocks ahead in your journey.
                ONPASSIVE platform is built to provide end to end coverage.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="card cardh">
            <div class="card-img-top">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(feb-24)/assets/image/icon3.png"
                class="icon3"
                alt="ONPASSIVE- Real Time Analytics"
              />
            </div>
            <div class="card-title">
              <h4 class="fourth-section-content3">Real-time everything</h4>
            </div>
            <div class="card-body bg-violet">
              <p class="card-text text-white">
                Instantly develop content, get real-time analytics on traffic,
                automate your online business with ONPASSIVE and make decisions
                that can boost your business production rate in seconds
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="card cardh">
            <div class="card-img-top">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(feb-24)/assets/image/icon4.png"
                class="icon4"
                alt="ONPASSIVE - Power of Artificial Intelligence"
              />
            </div>
            <div class="card-title">
              <h4 class="fourth-section-content3">Bring Customer Closer</h4>
            </div>
            <div class="card-body bg-violet">
              <p class="card-text text-white">
                Bring the power of Artificial Intelligence to your audience,
                enhance the user experience, and get more visibility and have
                control over your content in real-time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="fifth-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h4 class="fifth-section-content1 text-white">Testimonials</h4>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row d-flex justify-content-center">
        <div class="col-md-10 col-lg-9 col-xl-8">
          <div class="card card-main border-0 text-center">
            <div
              id="carouselExampleIndicators"
              class="carousel slide"
              data-ride="carousel"
            >
              <!-- <ol class="carousel-indicators">
                        <li data-target="#carouselExampleIndicators" data-slide-to="0"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1" class="active"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                    </ol> -->
              <owl-carousel-o [options]="customOptions">
                <ng-template class="carousel-item" carouselSlide>
                  <div class="card border-0 card-0">
                    <div class="card profile py-3 px-4">
                      <div class="text-center">
                        <img
                          src="{{
                            onPassiveBaseUrl
                          }}onpassive(feb-24)/assets/image/testimonial1.jpg"
                          class="img-fluid profile-pic"
                          alt="ONPASSIVE Review - Ken Russo"
                        />
                      </div>
                      <h6 class="mb-0 mt-2 testimonial-content text-white">
                        Ken Russo
                      </h6>
                      <small class="text-white">IN IT TO WIN IT</small>
                    </div>
                    <img
                      class="img-fluid open-quotes"
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/comma.png"
                      alt="comma"
                    />
                    <p class="content mb-0 testimonial-content1">
                      Thanks for the shout out from Ash earlier today and thanks
                      for the kind words in response. However, it’s not about
                      me. Rather, it’s all about Ash and his awesome vision
                      which I immediately embraced back in July of 2018.
                    </p>
                    <img
                      class="img-fluid close-quotes ml-auto"
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/comma1.png"
                      alt="comma1"
                    />
                  </div>
                </ng-template>
                <ng-template class="carousel-item" carouselSlide>
                  <div class="card border-0 card-0">
                    <div class="card profile py-3 px-4">
                      <div class="text-center">
                        <img
                          src="{{
                            onPassiveBaseUrl
                          }}onpassive(feb-24)/assets/image/testimonial2.jpg"
                          class="img-fluid profile-pic"
                          alt="ONPASSIVE Review  - James Yates"
                        />
                      </div>
                      <h6 class="mb-0 mt-2 testimonial-content text-white">
                        James Yates
                      </h6>
                      <small class="text-white">IN IT TO WIN IT</small>
                    </div>
                    <img
                      class="img-fluid open-quotes"
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/comma.png"
                      alt="comma"
                    />
                    <p class="content mb-0 testimonial-content1">
                      Mr. Ash could do the same as these 4 did but he is a
                      special man with a special heart. I thank you Mr. Ash
                      Mufareh and ONPASSIVE for taking me and 60,000+ regular
                      citizens with you to a company that has no limits on its
                      growth capabilities. My family and special friends will be
                      forever grateful to you!!
                    </p>
                    <img
                      class="img-fluid close-quotes ml-auto"
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/comma1.png"
                      alt="comma1"
                    />
                  </div>
                </ng-template>
                <ng-template class="carousel-item" carouselSlide>
                  <div class="card border-0 card-0">
                    <div class="card profile py-3 px-4">
                      <div class="text-center">
                        <img
                          src="{{
                            onPassiveBaseUrl
                          }}onpassive(feb-24)/assets/image/testimonial4.png"
                          class="img-fluid profile-pic"
                          alt="ONPASSIVE Review -Eva Farbas"
                        />
                      </div>
                      <h6 class="mb-0 mt-2 testimonial-content text-white">
                        Eva Farbas
                      </h6>
                      <small class="text-white">IN IT TO WIN IT</small>
                    </div>
                    <img
                      class="img-fluid open-quotes"
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/comma.png"
                      alt="comma"
                    />
                    <p class="content mb-0 testimonial-content1">
                      If you just read one article a day about our AI
                      Technology, the many elements of our Unique System, the
                      products, the services ONPASSIVE provides you will be
                      given such a powered knowledge this well to step into the
                      future. Yes the World is moving forward to a New Age and
                      yes Technology is rapidly developing with it. .
                    </p>
                    <img
                      class="img-fluid close-quotes ml-auto"
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(feb-24)/assets/image/comma1.png"
                      alt="comma1"
                    />
                  </div>
                </ng-template>
              </owl-carousel-o>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="sixth-section">
    <div class="container-fluid">
      <div class="row blog">
        <div class="col-md-12 col-lg-12">
          <div
            id="blogCarousel"
            class="carousel slide container-blog"
            data-ride="carousel"
          >
            <!-- Carousel items -->
            <owl-carousel-o [options]="customOptions">
              <ng-template carouselSlide class="carousel-item">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="item-box-blog">
                      <div class="item-box-blog-image">
                        <!--Date-->
                        <div class="item-box-blog-date bg-blue-ui white">
                          <span class="mon">24 Feb</span>
                        </div>
                        <!--Image-->
                        <figure>
                          <img
                            src="{{
                              onPassiveBaseUrl
                            }}onpassive(feb-24)/assets/image/blog1.jpg"
                            alt="Future with ONPASSIVE AI"
                          />
                        </figure>
                      </div>
                      <div class="item-box-blog-body">
                        <!--Heading-->
                        <div class="item-box-blog-heading">
                          <a
                            href="https://onpassive.com/blog/a-timeline-view-of-the-year-2020-against-multiple-timelines/"
                            tabindex="0"
                            target="_blank"
                            rel="noopener"
                          >
                            <h5 class="text-white blog-content1">
                              A Timeline View of the Year 2020 against Multiple
                              Timelines
                            </h5>
                          </a>
                        </div>
                        <!--Data-->
                        <div
                          class="item-box-blog-data"
                          style="padding: px 15px"
                        >
                          <p class="text-white blog-content2">
                            <i class="fa fa-user-o"></i> Admin,
                            <i class="fa fa-comments-o"></i> Comments(1)
                          </p>
                        </div>
                        <!--Text-->
                        <div class="item-box-blog-text">
                          <p class="text-white blog-content3">
                            “The forties are grown, the thirties yet more, and
                            the twenties roar.” We are now living in the 20s!
                            Isn’t it exciting? “The twenties” is too cool to
                            say, and it’s also old school. “The forties are
                            grown, the thirties yet more, and the twenties
                            roar.”
                          </p>
                        </div>
                        <!-- <div class="mt"> <a href="#" tabindex="0" class="btn bg-blue-ui white read">read more</a> </div>-->
                        <!--Read More Button-->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="item-box-blog">
                      <div class="item-box-blog-image">
                        <!--Date-->
                        <div class="item-box-blog-date bg-blue-ui white">
                          <span class="mon">24 Feb</span>
                        </div>
                        <!--Image-->
                        <figure>
                          <img
                            src="{{
                              onPassiveBaseUrl
                            }}onpassive(feb-24)/assets/image/blog2.jpg"
                            alt="ONPASSIVE - Sell Anything with Webinars"
                          />
                        </figure>
                      </div>
                      <div class="item-box-blog-body">
                        <!--Heading-->
                        <div class="item-box-blog-heading">
                          <a
                            href="https://onpassive.com/blog/what-makes-a-webinar-good-to-great/"
                            tabindex="0"
                            target="_blank"
                            rel="noopener"
                          >
                            <h5 class="text-white blog-content1">
                              What Makes a Webinar Good to Great?
                            </h5>
                          </a>
                        </div>
                        <!--Data-->
                        <div
                          class="item-box-blog-data"
                          style="padding: px 15px"
                        >
                          <p class="text-white blog-content2">
                            <i class="fa fa-user-o"></i> Admin,
                            <i class="fa fa-comments-o"></i> Comments(2)
                          </p>
                        </div>
                        <!--Text-->
                        <div class="item-box-blog-text">
                          <p class="text-white blog-content3">
                            Webinars are the most popular form of lead
                            generation. A presenter conducts the session, while
                            participants, well, they just participate. A webinar
                            sometimes includes a QnA session after the presenter
                            is done with his script.
                          </p>
                        </div>
                        <!-- <div class="mt"> <a href="#" tabindex="0" class="btn bg-blue-ui white read">read more</a> </div>-->
                        <!--Read More Button-->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="item-box-blog">
                      <div class="item-box-blog-image">
                        <!--Date-->
                        <div class="item-box-blog-date bg-blue-ui white">
                          <span class="mon">24 Feb</span>
                        </div>
                        <!--Image-->
                        <figure>
                          <img
                            src="{{
                              onPassiveBaseUrl
                            }}onpassive(feb-24)/assets/image/blog3.jpg"
                            alt="The Entertaiment Industry ONPASSIVE"
                          />
                        </figure>
                      </div>
                      <div class="item-box-blog-body">
                        <!--Heading-->
                        <div class="item-box-blog-heading">
                          <a
                            href="https://onpassive.com/blog/hollywood-model-the-future-of-content-creation/"
                            tabindex="0"
                            target="_blank"
                            rel="noopener"
                          >
                            <h5 class="text-white blog-content1">
                              Hollywood Model: The Future of Content Creation
                            </h5>
                          </a>
                        </div>
                        <!--Data-->
                        <div
                          class="item-box-blog-data"
                          style="padding: px 15px"
                        >
                          <p class="text-white blog-content2">
                            <i class="fa fa-user-o"></i> Admin,
                            <i class="fa fa-comments-o"></i> Comments(0)
                          </p>
                        </div>
                        <!--Text-->
                        <div class="item-box-blog-text">
                          <p class="text-white blog-content3">
                            The entertainment industry is mainly running by
                            attracting audiences, and the competition of gaining
                            attention has never been this healthy and increasing
                            every day with the debut of new participants from
                            the non-media labels bouncing over the content
                            creation.
                          </p>
                        </div>
                        <!-- <div class="mt"> <a href="#" tabindex="0" class="btn bg-blue-ui white read">read more</a> </div>-->
                        <!--Read More Button-->
                      </div>
                    </div>
                  </div>
                </div>
                <!--.row-->
              </ng-template>
              <!--.item-->
              <ng-template carouselSlide class="carousel-item active">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="item-box-blog">
                      <div class="item-box-blog-image">
                        <!--Date-->
                        <div class="item-box-blog-date bg-blue-ui white">
                          <span class="mon">24 Feb</span>
                        </div>
                        <!--Image-->
                        <figure>
                          <img
                            src="{{
                              onPassiveBaseUrl
                            }}onpassive(feb-24)/assets/image/blog4.jpg"
                            alt="Rebrand your Company with ONPASSIVE"
                          />
                        </figure>
                      </div>
                      <div class="item-box-blog-body">
                        <!--Heading-->
                        <div class="item-box-blog-heading">
                          <a
                            href="https://onpassive.com/blog/how-to-successfully-rebrand-your-company/"
                            tabindex="0"
                            target="_blank"
                            rel="noopener"
                          >
                            <h5 class="text-white blog-content1">
                              How to Successfully Rebrand Your Company?
                            </h5>
                          </a>
                        </div>
                        <!--Data-->
                        <div
                          class="item-box-blog-data"
                          style="padding: px 15px"
                        >
                          <p class="text-white blog-content2">
                            <i class="fa fa-user-o"></i> Admin,
                            <i class="fa fa-comments-o"></i> Comments(3)
                          </p>
                        </div>
                        <!--Text-->
                        <div class="item-box-blog-text">
                          <p class="text-white blog-content3">
                            A brand is basically the identity of a company. It
                            could be anything that customers associate with a
                            company, such as a logo, personified image,
                            products, or services. Not soon, but after some
                            time, companies feel the need for rebranding.
                          </p>
                        </div>
                        <!--    <div class="mt"> <a href="#" tabindex="0" class="btn bg-blue-ui white read">read more</a> </div>-->
                        <!--Read More Button-->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="item-box-blog">
                      <div class="item-box-blog-image">
                        <!--Date-->
                        <div class="item-box-blog-date bg-blue-ui white">
                          <span class="mon">24 Feb</span>
                        </div>
                        <!--Image-->
                        <figure>
                          <img
                            src="{{
                              onPassiveBaseUrl
                            }}onpassive(feb-24)/assets/image/blog5.jpg"
                            alt="ONPASSIVE – Sell Your Story not the Product"
                          />
                        </figure>
                      </div>
                      <div class="item-box-blog-body">
                        <!--Heading-->
                        <div class="item-box-blog-heading">
                          <a
                            href="https://onpassive.com/blog/sell-your-story-not-the-product-connect-with-your-customer-via-storytelling/"
                            tabindex="0"
                            target="_blank"
                            rel="noopener"
                          >
                            <h5 class="text-white blog-content1">
                              Sell Your Story Not the Product: Connect With Your
                              Customer via Storytelling
                            </h5>
                          </a>
                        </div>
                        <!--Data-->
                        <div
                          class="item-box-blog-data"
                          style="padding: px 15px"
                        >
                          <p class="text-white blog-content2">
                            <i class="fa fa-user-o"></i> Admin,
                            <i class="fa fa-comments-o"></i> Comments(3)
                          </p>
                        </div>
                        <!--Text-->
                        <div class="item-box-blog-text">
                          <p class="text-white blog-content3">
                            In today’s digital world, the utilization of
                            storytelling is across several different types of
                            media by businesses looking forward and leveraging
                            its power to build a strong connection with their
                            customers.
                          </p>
                        </div>
                        <!--  <div class="mt"> <a href="#" tabindex="0" class="btn bg-blue-ui white read">read more</a> </div>-->
                        <!--Read More Button-->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="item-box-blog">
                      <div class="item-box-blog-image">
                        <!--Date-->
                        <div class="item-box-blog-date bg-blue-ui white">
                          <span class="mon">23 Feb</span>
                        </div>
                        <!--Image-->
                        <figure>
                          <img
                            src="{{
                              onPassiveBaseUrl
                            }}onpassive(feb-24)/assets/image/blog6.jpg"
                            alt="Fight Online Challenges with ONPASSIVE AI"
                          />
                        </figure>
                      </div>
                      <div class="item-box-blog-body">
                        <!--Heading-->
                        <div class="item-box-blog-heading">
                          <a
                            href="https://onpassive.com/blog/how-to-fight-online-challenges-with-ai-opportunities/"
                            tabindex="0"
                            target="_blank"
                            rel="noopener"
                          >
                            <h5 class="text-white blog-content1">
                              How to Fight Online Challenges with AI
                              Opportunities
                            </h5>
                          </a>
                        </div>
                        <!--Data-->
                        <div
                          class="item-box-blog-data"
                          style="padding: px 15px"
                        >
                          <p class="text-white blog-content2">
                            <i class="fa fa-user-o"></i> Admin,
                            <i class="fa fa-comments-o"></i> Comments(3)
                          </p>
                        </div>
                        <!--Text-->
                        <div class="item-box-blog-text">
                          <p class="text-white blog-content3">
                            The term artificial intelligence (AI) may bring the
                            scenes of a sci-fi movie, but in today’s scenario,
                            it is already transforming several industries,
                            including marketing, online businesses. AI is
                            attracting huge attention as one tool that fixes
                            everything and accomplishes harder tasks with fewer
                            efforts, time and resources.
                          </p>
                        </div>
                        <!--  <div class="mt"> <a href="#" tabindex="0" class="btn bg-blue-ui white read">read more</a> </div>-->
                        <!--Read More Button-->
                      </div>
                    </div>
                  </div>
                </div>
                <!--.row-->
              </ng-template>
              <!--.item-->
            </owl-carousel-o>
            <!--.carousel-inner-->
            <!-- <ol class="carousel-indicators">
              <li data-target="#blogCarousel" data-slide-to="0" class="active"></li>
              <li data-target="#blogCarousel" data-slide-to="1"></li>
            </ol> -->
          </div>
          <!--.Carousel-->
        </div>
      </div>
    </div>
  </section>
  <section class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 text-center">
          <p class="copy-right">&copy; 2022 ONPASSIVE - ALL RIGHTS RESERVED</p>
        </div>
      </div>
    </div>
  </section>
  <!----------------------------------------------------------------------------------------->
</body>
